import React, { useState } from 'react';
import { Button, Icon, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { ImageGalleryDialog } from 'components';


interface IGallerySelectOwnImageProps {
  title: string,
  imagesTagIds: string,
  isOwnImages: boolean,
  cols: number,
  rowHeight: number,
  onImageSelect: (_data) => void
}

const GallerySelectOwnImage = ({
  title,
  imagesTagIds,
  isOwnImages,
  onImageSelect,
  cols,
  rowHeight
}: IGallerySelectOwnImageProps) => {
  const [openImageDialog, toggleOpenImageDialog] = useState<boolean>(false);

  return (
    <>
      <Button
        className="w-full max-w-300 mt-2 mr-2 bg-periwinkle-gray"
        variant="outlined"
        color="primary"
        size="large"
        onClick={() => toggleOpenImageDialog(true)}
      >
        <Icon className="mr-2">wallpaper</Icon>
        Select From Own Images
      </Button>
      {(imagesTagIds && openImageDialog && isOwnImages) ?
        <ImageGalleryDialog
          title={title}
          open={openImageDialog}
          setOpen={toggleOpenImageDialog}
          onImageSelect={onImageSelect}
          imageTagId={imagesTagIds}
          isPrivate
          cols={cols}
          rowHeight={rowHeight}
        />
        :
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          autoHideDuration={3000}
          onClose={() => toggleOpenImageDialog(false)}
          open={openImageDialog}
        >
          <MuiAlert elevation={6} variant="filled" severity="warning">
            You have no your own uploaded images.
            Firstly, you have to upload at least one image.
          </MuiAlert>
        </Snackbar>
      }
    </>
  );
};

export default GallerySelectOwnImage;
